










































































import { Component, Mixins } from "vue-property-decorator";
import { CREDENTIALS, TYPES_OF_STORAGE } from "@/config/consts";
import { translate, translateSelectorItems } from "@/utils";
import FormValidator from "@/mixins/FormValidator";
import { AuthService } from "@/services/auth.service";

@Component({})
export default class AuthView extends Mixins(FormValidator) {
  get edsCheckDisabled() {
    return false;
  }

  EnterDisable: boolean = false;
  iin = "";
  bin = "";
  selectedCredential = "";
  get credentials() {
    return translateSelectorItems.call(this, CREDENTIALS);
  }

  get links() {
    return [
      // {
      //   title: this.$t("auth-view.manuals.video-inctruction.title"),
      //   href: this.$t("auth-view.manuals.video-inctruction.href"),
      // },
      {
        title: this.$t("auth-view.manuals.get-eds.title"),
        href: this.$t("auth-view.manuals.get-eds.href"),
      },
    ];
  }

  storageType = TYPES_OF_STORAGE[0].value;
  get storageTypes() {
    return translateSelectorItems.call(this, TYPES_OF_STORAGE);
  }

  formRef = "form";
  error: ApiMessageObject | null = null;
  get errorMessage() {
    return translate(this.error)?.name;
  }
  public async authenticate() {
    if (!this.validateForm()) return;
    this.EnterDisable = true;

    const { result } = await (this.edsCheckDisabled
      ? AuthService.authenticateTest(
          this.bin,
          this.iin,
          this.selectedCredential,
        )
      : AuthService.authenticate(this.storageType));
    if (typeof result != "boolean") {
      this.error = result;
      this.EnterDisable = false;
      this.$router.push("/contracts");
    } else if (result) {
      this.EnterDisable = false;
      this.$router.push("/contracts");
    }
  }
}
